<script setup>

import {computed} from "vue";

const props = defineProps({
    minValue: {
        type: [Number, String],
        required: true
    },
    maxValue: {
        type: [Number, String],
        required: true
    },
    maxValueForIndividualStops: {
        type: Number,
        default: 16
    },
    stopContainerClass: {
        type: String,
        default: 'h-4'
    },
    stopClass: {
        type: String,
        default: 'transform -translate-x-1/2 text-xs text-gray-400'
    }
})

const valueStops = computed(() => {
    const stops = [];
    const min = parseInt(props.minValue);
    const max = parseInt(props.maxValue);
    if (max > props.maxValueForIndividualStops) {
        const step = Math.max(1, Math.floor((max - min)));
        for (let i = min; i <= max; i += step) {
            stops.push(i);
        }
        if (stops[stops.length - 1] !== max) {
            stops.push(max);
        }
    } else {
        for (let i = min; i <= max; i++) {
            stops.push(i);
        }
    }
    return stops;
})


</script>

<template>
    <div class="flex justify-between">
        <div
            v-for="n in valueStops"
            :key="n"
            :class="stopContainerClass"
        >
            <span
                :class="stopClass"
            >{{ n }}</span>
        </div>
    </div>

</template>

<style scoped>

</style>
